<div class="auth-full-height d-flex flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div class="m-2">
                            <div class="d-flex justify-content-center mt-3">
                                <img style="max-width:300px;width: 100%;" src="/assets/images/Logo-01.png" alt="">
                                <!-- <logo class="text-center" logoType="fold"></logo> -->
                            </div>
                            <div class="text-center mt-3">
                                <h3 class="fw-bolder">Reset Password</h3>
                            </div>
                            <div *ngIf="showError" class="alert alert-danger" role="alert">
                                <span [innerHTML]="errorMessage"></span>
                            </div>
                            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                Your password has been reset. Please <a [routerLink]="['/login']"> click here to log in. </a>
                            </div>
                            <form [formGroup]="resetPasswordForm" autocomplete="off" novalidate
                                (ngSubmit)="resetPassword(resetPasswordForm.value)">
                                <div class="form-group mb-3">
                                    <label for="password" class="col-form-label">Password:</label>
                                    <div class="col-md-12">
                                        <input type="password" id="password" formControlName="password"
                                            class="form-control" />
                                    </div>
                                    <div class="col-md-5">
                                        <em *ngIf="validateControl('password') && hasError('password', 'required')">Password
                                            is
                                            required</em>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label for="confirm" class="col-form-label">Confirm Password:</label>
                                    <div class="col-md-12">
                                        <input type="password" id="confirm" formControlName="confirm"
                                            class="form-control" />
                                    </div>
                                    <div class="col-md-5">
                                        <em *ngIf="validateControl('confirm') && hasError('confirm', 'required')">Confirmation
                                            is
                                            required</em>
                                        <em *ngIf="hasError('confirm', 'mustMatch')">Passwords must match</em>
                                    </div>
                                </div>
                                <br>
                                <button type="submit" class="btn btn-primary w-100"
                                    [disabled]="!resetPasswordForm.valid">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>